export const forum = {
  alerts: {
    createComment: {
      error: 'Er ging iets mis bij het aanmaken van je reactie.',
      success: 'Je reactie is geplaatst.',
    },
    createPost: {
      error: 'Er ging iets mis bij het aanmaken van je post.',
      success: 'Je post is aangemaakt.',
    },
    deleteComment: {
      error: 'Er ging iets mis bij het verwijderen van je reactie.',
      success: 'Je reactie is verwijderd.',
    },
    deletePost: {
      error: 'Er ging iets mis bij het verwijderen van je post.',
      success: 'Je post is verwijderd.',
    },
    editComment: {
      error: 'Er ging iets mis bij het bewerken van je reactie.',
      success: 'Je reactie is bewerkt.',
    },
    editPost: {
      error: 'Er ging iets mis bij het bewerken van je post.',
      success: 'Je post is bewerkt.',
    },
  },
  breadcrumb: {
    guidelines: 'Richtlijnen',
    root: 'Forum',
    saved: 'Bewaarde posts',
    self: 'Mijn posts',
  },
  comments: {
    communityProfileRequired: {
      action: 'Profiel openbaar zetten',
      description: 'Om te reageren heb je een openbaar Community-profiel nodig.',
    },
    error: {
      title: 'Fout bij het laden van de reacties.',
    },
    titleUnknown: 'Reacties',
    title_one: '{{count}} reactie',
    title_other: '{{count}} reacties',
  },
  createComment: {
    actions: {
      comment: 'Reageren',
    },
  },
  createPost: {
    actions: {
      post: 'Plaatsen',
    },
    disclaimer: 'Lees je eerst de <guidelinesLink>Community-richtlijnen</guidelinesLink> voor je een post plaatst?',
    fields: {
      content: {
        label: 'Inhoud',
      },
      tag: {
        description: 'Kies de tag die het best bij je post past.',
        label: 'Tag',
      },
      title: {
        label: 'Titel',
      },
    },
    title: 'Post aanmaken',
  },
  deleteComment: {
    actions: {
      confirm: 'Verwijder reactie',
    },
    description: 'Ben je zeker dat je je reactie wilt verwijderen?',
    title: 'Reactie verwijderen',
  },
  deletePost: {
    actions: {
      confirm: 'Verwijder post',
      confirmUnable: 'Ik snap het',
    },
    description: 'Ben je zeker dat je je post “{{title}}” wilt verwijderen?',
    descriptionUnable:
      'Je post kan je niet verwijderen, omdat andere freelancers een reactie plaatsten.<br/>Wil je je post toch graag verwijderen? Neem dan contact op met <emailLink href="mailto:community@creativeshelter.be">community@creativeshelter.be</emailLink>, dan doen we het nodige.',
    title: 'Post verwijderen',
    titleUnable: 'Verwijderen is niet mogelijk',
  },
  guidelines: {
    content:
      '<introduction>De Community-spelregels. Niet omdat het een spel is dat je kan uitspelen, maar misschien wel iemand schaakmat zetten met een terechte opmerking. Maar dan lief, ingepakt met watten en bubblewrap hé.</introduction>\n\n<subtitle>Lief zijn hé. Willen we dat afspreken?</subtitle>\n\n<paragraph>Het forum kwam er voor jou en alle andere Shelteraars, maar wij houden mee een oogje in ’t zeil. Grof taalgebruik, racistische opmerkingen, homofoob gedrag … daar is geen plaats voor.</paragraph>\n\n<paragraph>Lief zijn voor elkaar is de boodschap.</paragraph>\n\n<subtitle>Er zijn geen domme vragen of antwoorden</subtitle>\n\n<paragraph>Alle Shelteraars kunnen reageren, advies geven of hun mening delen bij gestelde vragen in het forum. ’t Kan dus zijn dat je niet met alles akkoord bent of dat er eens een foutje in een antwoord sluipt. Ook daar geldt: wees lief voor elkaar. Of zoals K3 het zou zeggen: verdraagzaam zijn!</paragraph>\n\n<paragraph>Een juridische vraag, tips over de boekhouding of auteursrechten? Dan kan het weleens zijn dat Creative Shelter zelf reageert.</paragraph>\n\n<subtitle>Gevoelige informatie? Die blijft binnen de Community-muren.<br />What happens at the forum, stays at the forum.</subtitle>\n\n<paragraph>Gevoelige situaties, uurtarieven, het adres van iemands oma … vertel je niet verder. Het forum is net de plek om in een veilige omgeving over zo’n topics te babbelen en te sparren, zonder dat het opeens de ronde gaat. Om te roddelen moet je in je groepschat met de vrienden zijn.</paragraph>',
    header: {
      title: 'Community-richtlijnen',
    },
  },
  moderatorDialog: {
    introduction:
      'Ik hou een oogje in ’t zeil! Gewoon, zeker zijn dat iedereen lief blijft voor elkaar en het hier een gezellig boeltje blijft. Vragen of complimenten? Vuur ze maar op me af!',
  },
  overview: {
    error: {
      title: 'Fout bij het laden van het forum.',
    },
    header: {
      title: 'Community forum',
    },
    postPreview: {
      pinned: 'Vastgezet',
    },
    savedPosts: {
      empty: 'Je hebt nog geen posts bewaard.',
      error: {
        title: 'Fout bij het laden van je bewaarde posts.',
      },
      title: 'Bewaarde posts',
    },
    selfPosts: {
      empty: 'Je hebt nog geen post aangemaakt.',
      error: {
        title: 'Fout bij het laden van je posts.',
      },
      title: 'Je posts',
    },
    timeline: {
      empty: 'Er werd nog niets gepost.',
      error: {
        title: 'Fout bij het laden van je startpagina.',
      },
      title: 'Startpagina',
    },
  },
  post: {
    card: {
      actions: {
        comment: 'Reageren',
        comments: '{{count}} reacties',
        like: 'Vind ik leuk ({{count}} likes)',
      },
      edited: 'bewerkt',
    },
    error: {
      title: 'Fout bij het laden van de post.',
    },
    systemMessages: {
      CommentDeletedByModerator:
        '{{moderator, ucfirst}} heeft deze reactie verwijderd omdat deze niet voldoet aan onze <guidelinesLink>richtlijnen</guidelinesLink>.',
      CommentDeletedByUser: 'Deze reactie is verwijderd.',
      LockedByModerator: '{{moderator, ucfirst}} heeft deze post vergrendeld. Reageren is niet meer mogelijk.',
      MovedByModerator: '{{moderator, ucfirst}} heeft deze post verplaatst van <bold>{{oldTag}}</bold> naar <bold>{{newTag}}</bold>.',
      unknownModerator: 'Een moderator',
    },
  },
  sidebar: {
    sections: {
      favoriteTags: 'Favoriete tags',
      quickLinks: 'Nuttige links',
      tags: 'Alle tags',
    },
    toggleFavoriteTag: 'Markeer {{tag}} als favoriet',
  },
  tags: {
    Announcements: {
      name: 'Aankondigingen',
    },
    Audiovisual: {
      name: 'Audiovisueel',
    },
    DigitalDesign: {
      name: 'Digitaal ontwerp',
    },
    FreelanceLife: {
      name: 'Freelance leven',
    },
    ItDevelopment: {
      name: 'IT-ontwikkeling',
    },
    LanguageAndCommunication: {
      name: 'Taal en communicatie',
    },
    OnlineContentCreation: {
      name: 'Online contentcreatie en storytelling',
    },
    PerformingArtists: {
      name: 'Uitvoerende kunstenaar',
    },
    Photography: {
      name: 'Fotografie',
    },
    VisualCommunication: {
      name: 'Visuele communicatie',
    },
  },
};
